import PropTypes from 'prop-types';
import { Link } from '@evertrue/et-components';
import Avatar from 'components/elements/avatar';
import StrikeThroughWrapper from 'components/containers/strikethrough-wrapper';

const TaskConstituentCell = ({ task }) => {
  if (!task) return null;

  const { contact = {}, target_contact_id, completed_at } = task;

  // Get name and url, defaulting to '-' if name is missing/empty
  let name_full = '-';
  let url = '';

  if (contact !== null && contact.contact_attributes) {
    const attrs = contact.contact_attributes;
    name_full =
      attrs.name_full?.trim() ||
      [attrs.name_first, attrs.name_last].filter(Boolean).join(' ').trim() ||
      attrs.name_nick?.trim() ||
      '-';
  }

  if (contact !== null && contact.profile_image && contact.profile_image.url) {
    url = contact.profile_image.url;
  }

  // Only show avatar and link if we have a valid contact name
  const hasValidContact = target_contact_id && name_full !== '-';

  return (
    <StrikeThroughWrapper hasStrikeThrough={!!completed_at}>
      {hasValidContact ? (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <Link title={`${name_full}'s Profile`} href={`/contact/${target_contact_id}`}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Avatar
                className="new-contact-card--avatar fs-exclude-data"
                name={name_full}
                url={url || ''}
                width={40}
              />
              <div className="journeys-contact-card-name table-toolbar-amount fs-exclude-data">{name_full}</div>
            </div>
          </Link>
        </span>
      ) : (
        <span>-</span>
      )}
    </StrikeThroughWrapper>
  );
};

TaskConstituentCell.propTypes = {
  task: PropTypes.object.isRequired,
};

export default TaskConstituentCell;
